import { Component } from '@angular/core';
import { TabGroupComponent } from '../../shared/components/tabs/tab-group/tab-group.component';
import { TabComponent } from '../../shared/components/tabs/tab/tab.component';
import { COMMON_IMPORTS } from '../../shared/imports/common-imports';
import { UserListComponent } from './user-list/user-list.component';
import { HistoricalDataComponent } from './historical-data/historical-data.component';
import { DialogService } from '../../shared/services/dialog.service';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [
    TabGroupComponent,
    TabComponent,
    COMMON_IMPORTS,
    UserListComponent,
    HistoricalDataComponent,
  ],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
})
export class AdminComponent {
  fetchUsersSubject = new Subject<void>();
  isUserListLoading = false;

  constructor(private readonly _dialogService: DialogService) {}

  onUserListLoadingChange(isLoading: boolean) {
    this.isUserListLoading = isLoading;
  }

  openNewUserDialog() {
    const dialogRef = this._dialogService.openNewUserDialog();
    dialogRef.afterClosed().subscribe(() => {
      this.fetchUsersSubject.next();
    });
  }
}
